module.exports = __webpack_public_path__ + "img/potencia_b.9f85aa27.svg";